<div class="page">
  <app-page-header page-title="properties.list.titleTabTagNfc"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'properties.list.titleTabTagNfc' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportProperties')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                  <button mat-raised-button (click)="onAssignTaggers()" color="primary" [disabled]="selection.selected.length === 0">
                    <mat-icon fontSet="fal" fontIcon="fa-repeat"></mat-icon>
                    {{ 'properties.list.assignTaggerBtn' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="name"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs column-center">
                    <mat-checkbox 
                      (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      
                      class="checkbox-insert">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox  
                      (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(element) : null"
                      [checked]="selection.isSelected(element)"
                      class="checkbox-insert">
                    </mat-checkbox>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'properties.fields.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.name }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="nameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nameFilter)"
                        class="reset-input-icon" *ngIf="nameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="admin">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">{{ 'properties.fields.admin' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <!-- <a routerLink="../../companies/detail/{{ element.admin?.company?._id}}">
                      {{ element.admin?.company?.name }}
                    </a> -->
                    {{ element.admin?.name }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="adminFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(adminFilter)"
                        class="reset-input-icon" *ngIf="adminFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="address">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'properties.fields.address' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.address.route }} {{ element.address.streetNumber }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="addressFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(addressFilter)"
                        class="reset-input-icon" *ngIf="addressFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="city">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'properties.fields.city' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.address.city }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="cityFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(cityFilter)"
                        class="reset-input-icon" *ngIf="cityFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="postalCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'properties.fields.postalCode' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.address.postalCode }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="postalCodeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(postalCodeFilter)"
                        class="reset-input-icon" *ngIf="postalCodeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="nfcTags">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md column-center">
                    {{ 'properties.fields.nfcTags' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <a class="ml-2" routerLink="../{{element._id}}/tagNfgList">
                      <span *ngIf="element.nfcTags && element.nfcTags > 0">{{ element.nfcTags }}</span>
                      <span *ngIf="!element.nfcTags || element.nfcTags === 0">0</span>
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="nfcTagsFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nfcTagsFilter)"
                        class="reset-input-icon" *ngIf="nfcTagsFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="user">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-sm column-center">
                    {{ 'properties.fields.user' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <span *ngIf="element.taggerId && element.taggerId.firstName !== ''">
                      {{ element.taggerId.firstName }} {{ element.taggerId.lastName }}
                    </span>
                    <span *ngIf="!element.taggerId">{{ 'common.words.dashes' | translate }}</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="userFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(userFilter)"
                        class="reset-input-icon" *ngIf="userFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
               
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->